const Dashboard = {

    // FIELDS
    "project_management": "Project Management",
    "farm_management": "Farm Management",
    "marketplace": "Marketplace",

    "project_tagline": "Manage census projects & timelines",
    "farm_tagline": "Agricultural data & farm records",
    "marketplace_tagline": "Community marketplace insights",

    // PAGE HEADER
    "dashboard": "Dashboard",

}

export default Dashboard;